import styles from './GuidanceCard.scss';
import React from 'react';
import cx from 'classnames';

interface GuidanceLinkProps extends React.ComponentProps<'a'> {
  children: React.ReactNode;
}

const GuidanceLink = ({ className, onClick, children, ...props }: GuidanceLinkProps) => {
  const classes = cx(styles.guidanceLink, className);

  return (
    <a href="/" onClick={onClick} className={classes} {...props}>
      <div className={styles.card}>{children}</div>
    </a>
  );
};

export default GuidanceLink;
